import React, { useContext } from 'react'
import { useSelector } from 'react-redux';
import { State } from '../../redux/store';
import { ExpenseInterface, ShowExpenseContext } from './types';
import { FaEdit } from 'react-icons/fa';
import { CiCircleRemove } from 'react-icons/ci';
import { filterSpecificDate, formatDate } from '../../functions/functions';
import { useTranslation } from 'react-i18next';

const DataExpenses = () => {
  const { expenses } = useSelector((state: State) => state.expenses);

  const {
    showEditModal, setShowEditModal,
    showDeleteModal, setShowDeleteModal,
    setSelectedExpense,
    day, month, showSwitchDate, startDate, endDate, selectedDate
   } = useContext(ShowExpenseContext)

  const handleEditExpense = (expense: ExpenseInterface) => {
    setShowEditModal(!showEditModal)
    setSelectedExpense(expense)
  }

  const handleDeleteExpense = (expense: ExpenseInterface) => {
    setShowDeleteModal(!showDeleteModal)
    setSelectedExpense(expense)
  }

  const { t } = useTranslation()

  return (
    <div className='grid md:grid-cols-3'>
    {expenses.length > 0 && (
      <div className="col-span-2 flex flex-col border">
        <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full sm:px-6 lg:px-8">
            <div className="overflow-hidden invoice print:w-full">
              <table className="min-w-full text-center text-sm font-light border border-black">
                <thead className="border-b font-medium bg-main text-white border-black">
                  <tr>
                    <th className="px-2 py-2 border-black border-r">{t("Note")}</th>
                    <th className="px-2 py-2 border-black border-r">{t("Montant")}</th>
                    <th className="px-2 py-2 border-black border-r">{t("Date")}</th>
                    <th className="px-2 py-2 border-black print:hidden border-r">{t("Actions")}</th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {
                  filterSpecificDate(
                    expenses, day, month, showSwitchDate, startDate, endDate, selectedDate
                  )
                  // expenses
                  ?.map((expense: ExpenseInterface, index) => (
                    <tr className="border-b border-black" key={index}>
                      <td className="whitespace-nowrap px-2 py-2 border-black border-r font-medium">
                        {expense.note}
                      </td>
                      <td className="whitespace-nowrap px-2 py-2 border-black border-r font-medium">
                        {expense.amount}
                      </td>
                      <td className="whitespace-nowrap px-2 py-2 border-black border-r font-medium">
                        {formatDate(expense.createdAt)}
                      </td>
                      <td className="flex justify-center items-center print:hidden border-r">
                        <FaEdit style={{ fontSize: "22px" }} className="text-second" onClick={() => handleEditExpense(expense)}/>
                        <CiCircleRemove style={{ fontSize: "22px" }} className="text-red" onClick={() => handleDeleteExpense(expense)}/>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td className="whitespace-nowrap px-2 py-2 border-black border-r font-medium md:text-2xl">{t("Total")} : </td>
                    <td colSpan={2} className="whitespace-nowrap px-2 py-2  font-medium md:text-2xl">
                      {
                        filterSpecificDate(
                          expenses, day, month, showSwitchDate, startDate, endDate, selectedDate
                        ).reduce((acc: number, currVal: ExpenseInterface) => acc + currVal.amount, 0)
                      }
                    </td>
                    <td className="whitespace-nowrap px-2 py-2 border-black border-r font-medium md:text-2xl"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      )}
    </div>
  )
}

export default DataExpenses